import React, { useEffect, useRef, useState } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import axiosInstance from "../../../redux/api";
import { useSelector } from "react-redux";

const TaxReturnForm = () => {
  const pdfRef = useRef();
  const [period, setPeriod] = useState("monthly");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [startYear, setStartYear] = useState(new Date().getFullYear());
  const [endYear, setEndYear] = useState(new Date().getFullYear());
  const [data, setData] = useState([]);
  const [showTables, setShowTables] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const [selectedQuarter, setSelectedQuarter] = useState(1);

  const TheUserdetails = useSelector(
    (state) => state.userProfile?.data?.response
  );

  const exportToPDF = () => {
    const input = pdfRef.current;
    html2canvas(input, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save("tax-return.pdf");
    });
  };
  const months = [
    ("January"),
    ("February"),
    ("March"),
    ("April"),
    ("May"),
    ("June"),
    ("July"),
    ("August"),
    ("September"),
    ("October"),
    ("November"),
    ("December"),
  ];
  const years = Array.from({ length: 21 }, (_, i) => 2025 + i);
  const Quaters = [
    {
      title: "Q1",
      id: 1,
    },
    {
      title: "Q2",
      id: 2,
    },
    {
      title: "Q3",
      id: 3,
    },
    {
      title: "Q4",
      id: 4,
    },
  ];

  useEffect(() => {
    const currentMonthIndex = new Date().getMonth(); // 0-11
    setSelectedMonth(months[currentMonthIndex]);
    setSelectedYear(new Date().getFullYear());
    setStartYear(new Date().getFullYear());
    setEndYear(new Date().getFullYear());

    // Fetch data on initial mount
    handleInitialLoad();
  }, []);

  const handleInitialLoad = async () => {
    try {
      const currentMonthIndex = new Date().getMonth();
      const monthString = months[currentMonthIndex];
      const year = new Date().getFullYear();

      const monthNumber = getMonthNumber(monthString);
      const daysInMonth = getDaysInMonth(year, parseInt(monthNumber));

      const data = {
        start_date: `${year}-${monthNumber}-01`,
        end_date: `${year}-${monthNumber}-${daysInMonth}`,
        user_id: 1,
      };

      const response = await axiosInstance.post(
        `invoice/get_vat_return_report`,
        data
      );
      setData(response?.data?.response);
      setShowTables(true);
    } catch (error) {
      console.error("Error fetching initial data:", error);
      // You might want to show a toast or handle this error differently
    }
  };

  const getMonthNumber = (monthString) => {
    const monthIndex = months.indexOf(monthString) + 1;
    return monthIndex < 10 ? `0${monthIndex}` : `${monthIndex}`;
  };

  const getDaysInMonth = (year, month) => {
    return new Date(year, month, 0).getDate();
  };

  const handleSearch = async () => {
    setSearchLoading(true);
    try {
      let data = {
        start_date: "",
        end_date: "",
        user_id: 1,
      };

      if (period === "monthly") {
        const monthNumber = getMonthNumber(selectedMonth);
        const daysInMonth = getDaysInMonth(selectedYear, parseInt(monthNumber));

        data = {
          start_date: `${selectedYear}-${monthNumber}-01`,
          end_date: `${selectedYear}-${monthNumber}-${daysInMonth}`,
          user_id: 1,
        };
      } else if (period === "yearly") {
        if (endYear < startYear) {
          // showToast(("End year cannot be less than start year"), "error");
          return;
        }

        data = {
          start_date: `${startYear}-01-01`,
          end_date: `${endYear}-12-31`,
          user_id: 1,
        };
      } else if (period === "quaterly") {
        // Handle quarterly selection
        const quarter = selectedQuarter; // Assuming you have a state for selectedQuarter
        const year = selectedYear; // Assuming you have a state for selectedYear

        // Define quarter date ranges
        let startMonth, endMonth, endDay;

        switch (quarter) {
          case 1: // Q1
            startMonth = "01";
            endMonth = "03";
            endDay = "31";
            break;
          case 2: // Q2
            startMonth = "04";
            endMonth = "06";
            endDay = "30";
            break;
          case 3: // Q3
            startMonth = "07";
            endMonth = "09";
            endDay = "30";
            break;
          case 4: // Q4
            startMonth = "10";
            endMonth = "12";
            endDay = "31";
            break;
          default:
            startMonth = "01";
            endMonth = "03";
            endDay = "31";
        }

        data = {
          start_date: `${year}-${startMonth}-01`,
          end_date: `${year}-${endMonth}-${endDay}`,
          user_id: 1,
        };
      }

      const response = await axiosInstance.post(
        `invoice/get_vat_return_report`,
        data
      );
      setData(response?.data?.response);
      setShowTables(true);
    } catch (error) {
      // showToast(error.message, "error");
    } finally {
      setSearchLoading(false);
    }
  };

  const handleReset = () => {
    const currentMonthIndex = new Date().getMonth(); // 0-11
    setSelectedMonth(months[currentMonthIndex]);
    setSelectedYear(new Date().getFullYear());
    setSelectedQuarter(1); // Reset to Q1
    setPeriod("monthly");
    handleInitialLoad();
    setShowTables(true);
    setData([]);
  };

  return (
    <>
      {showTables && (
        <div
          className="vat-report"
          style={{
            // direction: "rtl",
            backgroundColor: "#fff",
            padding: "20px 40px",
            fontFamily: "Tahoma, sans-serif",
          }}
        >
          <div>
            <div
              className="vat-padding"
              style={{
                padding: "0 50px",
              }}
            >
              <div className="vat-top d-flex justify-content-between align-items-center">
                <h2>{("Filters")}</h2>
                <div
                  className="d-flex align-items-center justify-content-between vat-left"
                  style={{ columnGap: "20px" }}
                >
                  <div className="form-group">
                    <label>{("Session")}</label>
                    <select
                      className="form-select form-control"
                      value={period}
                      onChange={(e) => setPeriod(e.target.value)}
                    >
                      <option value="monthly">{("Monthly")}</option>
                      <option value="yearly">{("Yearly")}</option>
                      <option value="quaterly">{("Quaterly")}</option>
                    </select>
                  </div>

                  {period === "monthly" ? (
                    <>
                      <div className="form-group">
                        <label>{("months")}</label>
                        <select
                          className="form-select   form-control"
                          value={selectedMonth}
                          onChange={(e) => {
                            setSelectedMonth(e.target.value);
                          }}
                        >
                          {months.map((month, index) => (
                            <option key={index}>{month}</option>
                          ))}
                        </select>
                      </div>
                      <div className="form-group">
                        <label>{("years")}</label>
                        <select
                          className="form-select  form-control"
                          value={selectedYear}
                          onChange={(e) =>
                            setSelectedYear(parseInt(e.target.value))
                          }
                        >
                          {years.map((year) => (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          ))}
                        </select>
                      </div>
                    </>
                  ) : period === "yearly" ? (
                    <>
                      <div className="form-group">
                        <label>{("From Year")}:</label>
                        <select
                          className="form-select  form-control"
                          value={startYear}
                          onChange={(e) =>
                            setStartYear(parseInt(e.target.value))
                          }
                        >
                          {years.map((year) => (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="form-group">
                        <label>{("To Year")}</label>
                        <select
                          className="form-select  form-control"
                          value={endYear}
                          onChange={(e) => setEndYear(parseInt(e.target.value))}
                        >
                          {years.map((year) => (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          ))}
                        </select>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="form-group">
                        <label>{("Quaterly")}</label>
                        <select
                          className="form-select form-control"
                          value={selectedQuarter}
                          onChange={(e) =>
                            setSelectedQuarter(parseInt(e.target.value))
                          }
                        >
                          {Quaters.map((quarter) => (
                            <option key={quarter.id} value={quarter.id}>
                              {(quarter.title)}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="form-group">
                        <label>{("Year")}</label>
                        <select
                          className="form-select form-control"
                          value={selectedYear}
                          onChange={(e) =>
                            setSelectedYear(parseInt(e.target.value))
                          }
                        >
                          {years.map((year) => (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          ))}
                        </select>
                      </div>
                    </>
                  )}
                </div>
                <div
                  className="d-flex align-items-center search-reset"
                  style={{ columnGap: "10px" }}
                >
                  <button className="submit-btn btn" onClick={handleSearch}>
                    <i className="fa fa-search"></i>
                    <span>Search</span>
                  </button>
                  <button className="submit-btn btn" onClick={handleReset}>
                    <i class="fa-solid fa-rotate"></i> <span>{("Reset")}</span>
                  </button>
                  <button
                    onClick={exportToPDF}
                    className="submit-btn btn w-auto expo-padding"
                  >
                    <i class="fa-solid fa-download"></i>
                    <span>Export</span>
                  </button>
                </div>
              </div>
            </div>
            {showTables && (
              <>
                <div
                  className="vat-sec1"
                  ref={pdfRef}
                  style={{
                    padding: "50px",
                    backgroundColor: "white",
                    width: "100%",
                    maxWidth: "800px",
                    margin: "0 auto",
                  }}
                >
                  <div className="vat-sec2">
                    <h1 style={{ textAlign: "center", marginBottom: "0" }}>
                      {("Tax Return Form")}
                    </h1>
                    <p style={{ textAlign: "center", fontSize: "15px" }}>
                      {period === "monthly"
                        ? `${selectedMonth} ${selectedYear}`
                        : `${("From")}: ${startYear} ${("To")}: ${endYear}`}
                    </p>
                    <div style={{ textAlign: "center", fontSize: "15px" }}>
                      {TheUserdetails && (
                        <strong>
                          {("Tax Number")}:{" "}
                          {TheUserdetails?.company_vat_number}
                        </strong>
                      )}
                    </div>

                    {/* Sales Table */}
                    <div className="table-responsive">
                      <table
                        className="table vat-table-sec"
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          marginTop: "25px",
                        }}
                      >
                        <thead>
                          <tr>
                            <th style={thStyle}>{("")}</th>
                            <th style={thStyle}>Amount</th>
                            <th style={thStyle}>Adjustment</th>
                            <th style={thStyle}>Tax Amount </th>

                          </tr>
                          <tr>
                            <th style={thStyle}>Tax</th>
                            <th style={thStyle}>Sales </th>
                            <th style={thStyle}>Credit notes issued this period</th>
                            <th style={thStyle}>VAT Due </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td style={tdStyle}>VAT</td>
                            <td style={tdStyle}>{data?.sale_total}</td>
                            <td style={tdStyle}>-{data.credit_total}</td>
                            <td style={tdStyle}>{data?.vat_out}</td>
                          </tr>
                          <tr>
                            <td style={tdStyle}>Zero Tax</td>
                            <td style={tdStyle}>00.00</td>
                            <td style={tdStyle}>-0.00</td>
                            <td style={tdStyle}>0.00</td>
                          </tr>
                          <tr>
                            <td style={tdStyle}>Tax Exempt</td>
                            <td style={tdStyle}>0.00</td>
                            <td style={tdStyle}>-0.00</td>
                            <td style={tdStyle}>0.00</td>
                          </tr>
                          <tr>
                            <td style={tdStyle}>Total</td>
                            <td style={tdStyle}>SAR {data?.sale_total} </td>
                            <td style={tdStyle}>SAR -{data.credit_total}</td>
                            <td style={tdStyle}>SAR {data?.vat_out}</td>
                          </tr>
                        </tbody>
                        <thead>

                          <tr>
                            <th style={thStyle}>Tax</th>
                            <th style={thStyle}>Purchases (SAR)</th>
                            <th style={thStyle}>Debit notes issued this period</th>
                            <th style={thStyle}>VAT Paid (SAR)</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td style={tdStyle}>VAT</td>
                            <td style={tdStyle}>{data?.purchase_total}</td>
                            <td style={tdStyle}>-{data.debit_total}</td>
                            <td style={tdStyle}>{data?.vat_in}</td>
                          </tr>
                          <tr>
                            <td style={tdStyle}>Zero Tax</td>
                            <td style={tdStyle}>0.00</td>
                            <td style={tdStyle}>-0.00</td>
                            <td style={tdStyle}>0.00</td>
                          </tr>
                          <tr>
                            <td style={tdStyle}>Tax Exempt</td>
                            <td style={tdStyle}>0.00</td>
                            <td style={tdStyle}>-0.00</td>
                            <td style={tdStyle}>0.00</td>
                          </tr>
                          <tr>
                            <td style={tdStyle}>Total</td>
                            <td style={tdStyle}>SAR {data?.purchase_total}</td>
                            <td style={tdStyle}>SAR -{data.debit_total}</td>
                            <td style={tdStyle}>SAR {data?.vat_in}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div className="table-responsive">
                      <table
                        className="table vat-table-sec"
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          marginTop: "25px",
                        }}
                      >
                        <tbody>
                          <tr>
                            <td style={tdStyle}>Total VAT due of current period</td>
                            <td style={tdStyle}>{data?.vat_payable} SAR</td>
                          </tr>
                          <tr>
                            <td style={tdStyle}>VAT Credit carried from previous period</td>
                            <td style={tdStyle}>0.00</td>
                          </tr>
                          <tr>
                            <td style={tdStyle}>Corrections for previous period (-5000 to 5000)</td>
                            <td style={tdStyle}>0.00</td>
                          </tr>
                          <tr>
                            <td style={tdStyle}>Net VAT Due</td>
                            <td style={tdStyle}>{data?.vat_payable}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

// Shared styles
const thStyle = {
  backgroundColor: "#e6f0fa",
  border: "1px solid #ccc",
  padding: "10px",
  fontSize: "14px",
};

const tdStyle = {
  border: "1px solid #ccc",
  padding: "10px",
  fontSize: "14px",
  textAlign: "center",
};

export default TaxReturnForm;

